import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, oneOf, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

// One reference image. The strip and the row draw a divider before the first style.
function Thumbnail({ url, layout, isDivided = false }) {
  const t = useTranslation()

  return (
    <li
      className={classnames(
        'image-references__item',
        layout !== 'column' && `image-references__item--${layout}`,
        isDivided && 'image-references__item--divided',
      )}
    >
      <img
        className="image-references__image"
        src={url}
        alt={t('shared.references.imageAlt')}
        loading="lazy"
      />
    </li>
  )
}

Thumbnail.propTypes = {
  url: string.isRequired,
  layout: oneOf(['column', 'strip', 'row']).isRequired,
  isDivided: bool,
}

export default memo(Thumbnail)
